import useReportStore from '../../../store/reports';

import { Select, MenuItem, FormControl } from '@mui/material';

import { ranges } from "../../../utils/utilities/RangePicker/helper";

const DateRangePicker = ({ field }) => {
  const reportType = useReportStore(state => state.reportType);

  const staticFilter = useReportStore(state => state.staticFilters[reportType]?.[field]) || "";
  const handleStaticFilters = useReportStore(state => state.handleStaticFilters);

  const handleFilter = useReportStore(state => state.handleFilter);

  const handleChange = (e) => {
    let val = e.target.value;
    handleStaticFilters(reportType, field, val);
    if (val === "Custom") return;

    let range = ranges.find(range => range.label === val);
    const { start, end } = range.getRange();
    handleFilter({ $gte: start, $lte: end }, reportType, field);
  }

  return (
   <FormControl sx={{bgcolor: '#f8f8f8'}} fullWidth>
    <Select
      id="report-type"
      size="small"
      variant='outlined'
      value={staticFilter}
      onChange={handleChange}
    >
      {ranges.map((range, index) => 
        <MenuItem key={range.label} value={range.label}>{range.label}</MenuItem>
      )}
      <MenuItem value="Custom">Custom</MenuItem>
    </Select>
  </FormControl>
  )
};

export default DateRangePicker;

